import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight } from "lucide-react";
import { useSite } from "@/lib/site";

export default function CityLinks({ service, exclude, title }) {
  const { cities } = useSite();
  const list = cities.filter((c) => c.slug !== exclude);
  if (!list.length) return null;
  return (
    <section className="container-x py-16" data-testid="city-links">
      <div className="eyebrow">We Serve In</div>
      <h2 className="mt-3 text-3xl md:text-4xl text-[color:var(--dh-navy)]">{title || `${service.title} across Uttarakhand.`}</h2>
      <div className="mt-8 flex flex-wrap gap-3">
        {list.map((c) => (
          <Link
            key={c.slug}
            to={`/services/${service.slug}/${c.slug}`}
            className="group inline-flex items-center gap-2 px-5 py-3 rounded-full border border-[color:var(--dh-line)] bg-white hover:border-[color:var(--dh-orange)] hover:-translate-y-0.5 transition-[transform,border-color] duration-200"
            data-testid={`city-link-${c.slug}`}
          >
            <MapPin className="w-4 h-4 text-[color:var(--dh-orange)]" />
            <span className="font-semibold text-[color:var(--dh-navy)]">{service.title} in {c.name}</span>
            <ArrowUpRight className="w-4 h-4 text-[color:var(--dh-slate)] group-hover:text-[color:var(--dh-orange)] transition-colors" />
          </Link>
        ))}
      </div>
    </section>
  );
}
